<template>
  <div>
    <h2 class="section-title">Se a sua agenda vira caos, todo o resto vira retrabalho</h2>
    <p class="section-subtitle">
      Clínicas de neurodesenvolvimento lidam com rotinas delicadas. Quando o controle falha, o time perde tempo,
      aumenta o risco de erro e o responsável fica inseguro.
    </p>

    <div class="cards">
      <div class="card">
        <div class="icon" aria-hidden="true">📅</div>
        <h3 class="card-title">Agenda desorganizada</h3>
        <p class="card-text">Reagendamentos, atrasos e falta de visão clara do dia geram quebra no atendimento.</p>
      </div>

      <div class="card">
        <div class="icon" aria-hidden="true">🔁</div>
        <h3 class="card-title">Retrabalho operacional</h3>
        <p class="card-text">Informações que deveriam estar prontas acabam sendo repetidas e verificadas manualmente.</p>
      </div>

      <div class="card">
        <div class="icon" aria-hidden="true">💳</div>
        <h3 class="card-title">Erros no financeiro</h3>
        <p class="card-text">Contas, recebimentos e convênios precisam estar coerentes para proteger a saúde do caixa.</p>
      </div>

      <div class="card">
        <div class="icon" aria-hidden="true">🧩</div>
        <h3 class="card-title">Dificuldade com convênios</h3>
        <p class="card-text">Sem um fluxo bem definido, cada caso vira exceção e o time fica sobrecarregado.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'PainPointsSection' }
</script>

<style scoped>
.cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-top: 22px;
}

.card {
  padding: 18px;
}

.icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(77, 186, 135, 0.12);
}

.card-title {
  font-size: 16px;
  margin: 12px 0 6px;
}

.card-text {
  margin: 0;
  color: var(--easy-muted);
  line-height: 1.55;
  font-size: 14px;
}

@media (max-width: 980px) {
  .cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .cards {
    grid-template-columns: 1fr;
  }
}
</style>
